<template>
 <div id="edit-attachment-promissory" class="modal fade" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
   <div class="modal-content">
    <div class="modal-header">
     <h4 class="modal-title text-left">Editar Estatus de Pagaré</h4>
    </div>
    <div class="modal-body">
     <!--
     <sys-form :inputs="formFields"/>
     -->
     <div class="form">
      <div class="form-group row">
       <div class="col-sm-6">
        <label for="folio">Folio</label>
        <div class="input-group">
         <input id="folio" disabled class="form-control" type="text" :value="promissory.folio">
        </div>
       </div>
      </div>
      <div class="form-group row">
       <div class="col-sm-12">
        <label for="reason">Seleccionar Nuevo Estatus </label>
        <select v-model="reason" id="reason" class="form-control">
          <option selected>Activo</option>
          <option> Cancelado </option>
          <option> Expirado </option>
          <option> Recuperado </option>
        </select>
       </div>
      </div>
     </div>
    </div>
    <div class="modal-footer">
     <button type="button" class="btn btn-default" data-dismiss="modal">Cancelar</button>
     <button @click="editPromissory" type="button" class="btn btn-primary"> Guardar </button>
    </div>
   </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
 </div><!-- /.modal -->
</template>

<script>
import promissoriesService from '../../services/promissories'
import sysForm from '../shared/Form'

export default {
  name: 'EditAttachmentPromissory',
  components: { sysForm },
  props: {
    promissory: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      formHasErrors: false,
      reason: '',
      promissoryId: 0
    }
  },
  methods: {
    editPromissory () {
      this.formHasErrors = false
      promissoriesService.edit(this.promissory.id, {reason: this.reason})
        .then(response => {
          alert('Pagaré editado correctamente')
          window.location.reload()
        })
        .catch(error => {
          if (error.message === 'Unprocessable Entity') {
            this.formHasErrors = true
          }
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/attachments/EditAttachmentPromissory.vue